import Container from './RedirectContainer'

export default Container